// extracted by mini-css-extract-plugin
export default {"base":"components-Macro-components-imageWithCaption__base--nSPkf"};